import { CommonModule } from '@angular/common';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { TranslateModule } from '@ngx-translate/core';
import { EditorModule } from '@tinymce/tinymce-angular';
import { PhotoUploadModule } from 'app/assessment/photo-upload/photo-upload.module';
import { QuestionsModule } from 'app/assessment/questions/questions.module';
import { AssessmentUtilitiesModule } from 'app/assessment/utilities/assessment-utilities.module';
import { EquipmentDialogComponent } from 'app/equipment/components/equipment-dialog/equipment-dialog.component';
import { EquipmentModule } from 'app/equipment/equipment.module';
import { MaterialModule } from 'app/material.module';
import { RecommendationModule } from 'app/recommendation/recommendation.module';
import { SharedModule } from 'app/shared/shared.module';

import { ErgoEvalCompleteEvaluationDialogComponent } from './components/ergo-eval-complete-evaluation-dialog/ergo-eval-complete-evaluation-dialog.component';
import { ErgonomicsEvaluationReportDialogComponent } from './components/ergonomics-evaluation-report-dialog/ergonomics-evaluation-report-dialog.component';
import { EvaluationPdfViewComponent } from './components/evaluation-pdf-view/evaluation-pdf-view.component';
import { EvaluationStepperComponent } from './components/evaluation-stepper/evaluation-stepper.component';
import { EvaluationComponent } from './components/evaluation.component';
import { EvaluationRoutingModule, routedComponents } from './evaluation-routing.module';
import { EvaluationRestConnectorService } from './services/evaluation-rest-connector.service';
import { EvaluationService } from './services/evaluation.service';
import { EvaluationEffects, evaluationReducer } from './state';

@NgModule({
  imports: [
    StoreModule.forFeature('evaluation', evaluationReducer),
    EffectsModule.forFeature([
      EvaluationEffects,
    ]),
    CommonModule,
    SharedModule,
    MaterialModule,
    ReactiveFormsModule,
    FormsModule,
    EditorModule,
    QuestionsModule,
    EvaluationRoutingModule,
    PhotoUploadModule,
    EquipmentModule,
    AssessmentUtilitiesModule,
    TranslateModule,
    RecommendationModule,
  ],
  providers: [
    EvaluationService,
    EvaluationRestConnectorService,
    EvaluationEffects,
  ],
  exports: [
    EvaluationComponent,
    EvaluationPdfViewComponent,
    EvaluationStepperComponent,
    ErgonomicsEvaluationReportDialogComponent,
    ErgoEvalCompleteEvaluationDialogComponent,
  ],
  entryComponents: [
    ErgoEvalCompleteEvaluationDialogComponent,
    EquipmentDialogComponent,
  ],
  declarations: [
    EvaluationPdfViewComponent,
    EvaluationStepperComponent,
    ErgonomicsEvaluationReportDialogComponent,
    ErgoEvalCompleteEvaluationDialogComponent,
    routedComponents,
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class EvaluationModule { }
